import bindAll from "lodash.bindall";

class WEBSocket{
    constructor(parent){
        this.wasSocketEverActive =false;
        this.ws = null;
        this.wasSocketEverActive = false;
        this.checkForNewConnection();
        this._parent=parent;
        this.shouldStopHearing = false;
        bindAll(this,[
            "checkForNewConnection"
        ])
        
    }
    checkForNewConnection(){
        //create a new websocket connection
        this.ws = new WebSocket("ws://localhost:20111");
        //attach listeners to that ws
        //1)Open
        this.ws.addEventListener("open", () =>{
            console.log("Connection in Client has been opened!!");
            this.wasSocketEverActive = true;
            this._parent.connectionHandler(true);
          });
        //2)While recieving a message
        this.ws.addEventListener('message', (event) =>{
            console.log("Recieved message from PictoBlox");
            const messageObject = JSON.parse(event.data);
              switch(messageObject.type){
                //Here all the cases will be handled according to the event received...
                case "setBoard":
                  this._parent.bleInstance.setBoard(messageObject.board);
                  this._parent.setCurrentBoard(messageObject.board);
                  break;
                case "sendDataToBoard":
                  this._parent.bleInstance.writeDataOnBle(messageObject.data);
                  break;
                case "disconnectBLE":
                  this._parent.bleInstance.disconnectBleConnectedPort();
                  break;
                case "CLIENT_BUSY":
                  this.shouldStopHearing = true;
                  this.ws.close();
                  window.alert("Chromebook link is already running in some other tab,please close this tab.")
                default:
                  console.log("Unknown event from PictoBlox");
              }
          });
        //3)When connection is closed due to any reason
        this.ws.addEventListener("close", (event)=>{
            console.log("Connection has been closed");
            //this.disconnectBleConnectedPort();
            if(this.wasSocketEverActive)
            {
                this.wasSocketEverActive = false;
                this._parent.connectionHandler(false);
                if(this._parent.bleInstance.isConnected()){
                  //Closing the BLE connection
                  this._parent.bleInstance.disconnectBleConnectedPort();
                }
                console.log("Connection has been closed!!")
            }
            //We will try listening for connection on every close...
            console.log("Trying For new Connection");
            if(!this.shouldStopHearing){
              setTimeout(()=>{
                this.checkForNewConnection(); 
            },1000);
            }
          });

    }
    
}

export default WEBSocket;